import React from 'react'
import { Collapse } from 'antd'
import { isEmpty } from 'lodash'

const { Panel } = Collapse

const ContactsCollapse = ({ children, emptyText }) => (
  <Collapse>
    {isEmpty(children) && <Panel header={emptyText}>{emptyText}</Panel>}
    {!isEmpty(children) && children}
  </Collapse>
)

export default ContactsCollapse



// WEBPACK FOOTER //
// ./src/components/contacts/Collapse.js